import React from 'react';
import SelectInput from 'screens/components/basic/SelectInput';
import TextInput from 'screens/components/basic/TextInput';

const Header = (props) => {
    const { typeOptions } = props;
    
    return (
        <div className="header_container pb-0 pl-4 pr-4">
            <div className="d-flex flex-row">
                <div className="d-flex flex-wrap col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 mr-0">
                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-2 flex-fill p-2">
                        <TextInput
                            name={`integrationNameFilter`}
                            fullWidth={true}
                            hintText="Search Name..."
                            label="Name"
                            floatingLabelText="Search Name"
                        />
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 flex-fill p-2">
                        <SelectInput
                            defaultValue={"0"}
                            name={`integrationSelectedType`}
                            fullWidth={true}
                            label="Type"
                            floatingLabelText="Select Type"
                            hintText="Select a category to display"
                            style={{ fontSize: "16px", letterSpacing: "-0.25px" }}
                            options={typeOptions}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Header;
